export type PlatformDashboardView = 'analytics' | 'health' | 'management';

export const getPlatformDashboardView = (
    pathname: string,
    hasManagementComponent: boolean
): PlatformDashboardView => {
    const normalizedPath = pathname.toLowerCase();
    if (normalizedPath.endsWith('/health')) return 'health';
    if (normalizedPath.endsWith('/management') && hasManagementComponent) return 'management';
    return 'analytics';
};

export const getAvailablePlatformDashboardViews = (hasManagementComponent: boolean): PlatformDashboardView[] =>
    hasManagementComponent ? ['analytics', 'health', 'management'] : ['analytics', 'health'];

export const shouldOpenInitialPlatformDateModal = (
    isLoading: boolean,
    organizationCount: number,
    hasConfirmedInitialDateRange: boolean,
    activeView: PlatformDashboardView
): boolean => !isLoading && organizationCount > 0 && !hasConfirmedInitialDateRange && activeView !== 'management';
